import gql from 'graphql-tag'

export const sendFieldValueRequest = gql`
  mutation SendFieldValueRequest(
    $startingPositionOnSheet: Int!
    $barcodeSettingId: Int!
    $ids: [String!]!
    $token: String!
    $userId: Int!
    $userEmail: String!
  ) {
    sendFieldValueRequest(
      input: {
        startingPositionOnSheet: $startingPositionOnSheet
        barcodeSettingId: $barcodeSettingId
        ids: $ids
        token: $token
        userId: $userId
        userEmail: $userEmail
      }
    ) {
      pdfData {
        location
      }
      errors
    }
  }
`
